var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M19.5621 12.098L21.0931 14.75C22.0601 16.424 21.4861 18.565 19.8131 19.531C19.2801 19.838 18.6771 20 18.0631 20H16.0001V22L11.0001 18.5L16.0001 15V17H18.0621C18.1501 17 18.2361 16.977 18.3121 16.933C18.5251 16.81 18.6131 16.555 18.5331 16.332L18.4951 16.25L16.9641 13.598L19.5621 12.098ZM7.73705 9.384L8.26705 15.464L6.53706 14.464L5.50505 16.25C5.46105 16.326 5.43805 16.412 5.43805 16.5C5.43805 16.745 5.61505 16.95 5.84805 16.992L5.93805 17H9.00005V20H5.93805C4.00505 20 2.43805 18.433 2.43805 16.5C2.43805 15.886 2.60005 15.282 2.90705 14.75L3.93805 12.964L2.20605 11.964L7.73605 9.384H7.73705ZM13.7501 2.969C14.2821 3.276 14.7241 3.718 15.0311 4.25L16.0611 6.036L17.7941 5.036L17.2641 11.116L11.7321 8.536L13.4641 7.536L12.4331 5.75C12.3891 5.674 12.3261 5.61 12.2501 5.567C12.0371 5.444 11.7721 5.495 11.6191 5.677L11.5671 5.75L10.0371 8.402L7.43806 6.902L8.96805 4.25C9.93505 2.576 12.0761 2.002 13.7501 2.969Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }